import {Component, EmbeddedViewRef, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';

@Component({
  selector: 'cat-tree-node-template-loader',
  template: '',
})
export class TreeNodeTemplateLoaderComponent implements OnInit, OnDestroy {

  @Input() template: TemplateRef<any>;
  @Input() node: any;

  view: EmbeddedViewRef<any>;

  constructor(public viewContainer: ViewContainerRef) {
  }

  ngOnInit() {
    this.view = this.viewContainer.createEmbeddedView(this.template, {
      $implicit: this.node,
    });
  }

  ngOnDestroy() {
    this.view.destroy();
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/widgets/explorer/components/tree-node-template-loader/tree-node-template-loader.component.ts